import styled from 'styled-components'

export const Container = styled.div`
  text-align: left;
  font-size: ${props => props.theme.texts.bodyMRegular.fontSize};
  font-family: ${props => props.theme.texts.bodyMRegular.fontFamily};
  line-height: ${props => props.theme.texts.bodyMRegular.lineHeight};
  color: ${props => props.theme.colors.black};

  p {
    margin: ${props => props.theme.whiteLabel.spacing.sp16} 0;
  }

  border-bottom: 1px solid ${props => props.theme.colors.grey.tone400};
  padding-bottom: ${props => props.theme.whiteLabel.spacing.sp8};

  strong {
    font-family: ${props => props.theme.texts.bodyMBold.fontFamily};
    font-weight: ${props => props.theme.texts.bodyMBold.fontWeight};
    line-height: ${props => props.theme.texts.bodyMBold.lineHeight};
    letter-spacing: ${props => props.theme.texts.bodyMBold.letterSpacing};
  }
`
